document.addEventListener("turbo:load", function() {
  searchContractNotes();
  initializeBrokerAutoFill();
  formatContractNumber();
  initializeContractDatePrefix();
});

function searchContractNotes() {
  const input = document.getElementById("contract-search-input");
  const form = document.getElementById("contract-search-form");
  const hiddenInput = document.getElementById("selected-contract-ids");
  const colourInput = document.getElementById("color-filter-select");
  const dateInput = document.getElementById("contract_date");

  if (!input || !form) return;

  if (input.value.trim() !== "") {
    input.focus();
    input.setSelectionRange(input.value.length, input.value.length);
  }

  let debounceTimer;

  input.addEventListener("input", function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      form.dataset.searchOnly = "true";
      form.requestSubmit();
    }, 1300);
  });

  if (dateInput && form) {
    dateInput.addEventListener("change", function() {
      form.requestSubmit();
    });
  }

  if (colourInput) {
    colourInput.addEventListener("change", function () {
      form.requestSubmit();
    });
  }

  if (hiddenInput) {
    form.addEventListener("submit", function (e) {
      if (form.dataset.searchOnly === "true") {
        delete form.dataset.searchOnly;
        return;
      }

      const selected = Array.from(document.querySelectorAll(".contract-checkbox:checked")).map(cb => cb.value);
      if (selected.length === 0) {
        e.preventDefault();
        alert("Please select at least one contract to update status.");
        return;
      }
      hiddenInput.value = selected.join(",");
    });
  }
}

function initializeBrokerAutoFill() {
  const sellerBrokerSelect = document.getElementById("seller_broker_id");
  const financerBrokerSelect = document.getElementById("financer_broker_id");
  const buyerBrokerSelect = document.getElementById("buyer_broker_id");

  if (!sellerBrokerSelect) return;

  sellerBrokerSelect.addEventListener("change", () => {
    const selectedValue = sellerBrokerSelect.value;

    if (financerBrokerSelect && (financerBrokerSelect.value === "" || financerBrokerSelect.dataset.autofilled === "true")) {
      financerBrokerSelect.value = selectedValue;
      financerBrokerSelect.dataset.autofilled = "true";
    }

    if (buyerBrokerSelect && (buyerBrokerSelect.value === "" || buyerBrokerSelect.dataset.autofilled === "true")) {
      buyerBrokerSelect.value = selectedValue;
      buyerBrokerSelect.dataset.autofilled = "true";
    }
  });

  if (financerBrokerSelect) {
    financerBrokerSelect.addEventListener("change", () => {
      financerBrokerSelect.dataset.autofilled = "false";
    });
  }

  if (buyerBrokerSelect) {
    buyerBrokerSelect.addEventListener("change", () => {
      buyerBrokerSelect.dataset.autofilled = "false";
    });
  }
}
function formatContractNumber() {
  const input = document.querySelector('input[name="contract_note[contract_no]"]');
  if (!input) return;

  input.addEventListener("blur", () => {
    let val = input.value.toUpperCase();
    const parts = val.split('/');

    if (/^\d{1,5}$/.test(parts[0])) {
      parts[0] = parts[0].padStart(5, '0');
    }

    input.value = parts.join('/');
  });
}

function initializeContractDatePrefix() {
  const contractDateInput = document.getElementById("contract_note_contract_date");
  const contractNoSuffixInput = document.getElementById("contract-no-suffix");
  const prefixDisplay = document.getElementById("prefix-display");

  if (!contractDateInput || !prefixDisplay) return;

  // Update prefix when contract date changes
  contractDateInput.addEventListener("change", () => {
    const contractDate = new Date(contractDateInput.value);
    const currentYear = contractDate.getFullYear();
    const month = contractDate.getMonth() + 1; // getMonth() is 0-indexed
    
    let fyStart = currentYear;
    let fyEnd = currentYear + 1;
    
    // If the date is before April (month < 4), the financial year started in the previous calendar year
    if (month < 4) {
      fyStart = currentYear - 1;
      fyEnd = currentYear;
    }
    
    const fy = `${fyStart.toString().slice(-2)}-${fyEnd.toString().slice(-2)}`;
    const newPrefix = `AKRK/${fy}/`;
    
    // Update the display and data attribute
    prefixDisplay.textContent = newPrefix;
    contractNoSuffixInput.dataset.prefix = newPrefix;
  });
}



